require('./src/datepicker.module');
require('./src/components/ac.datepicker.service');
require('./src/config/ac.datepicker.config');
require('./src/controllers/ac.datepicker.controller');
require('./src/css/styles.datepicker.scss');
require('./src/directives/ac.datepicker.directive');
require('./src/directives/uib.datepicker.popup.override.directive');
require('./src/templates/ac.datepicker.templates');